var $0c1ee0b8d50940d9$exports = {};
$0c1ee0b8d50940d9$exports = {
    "Clear search": `Keres\xe9s t\xf6rl\xe9se`
};


export {$0c1ee0b8d50940d9$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
